<template>
    <div id="contenedor-listado-mobiles">
        <template
            v-for="(obra, index) in listadoObras">
            <v-card
                :key="index"
                class="mb-2">
                <v-card-title
                  class="justify-space-between">
                  <div
                    class="d-inline-block text-truncate">
                    {{ obra.clave }}
                  </div>
                  <div
                    class="d-inline-block">
                    <opciones
                      :obra="obra">
                    </opciones>
                  </div>
                </v-card-title>
                <v-card-text>
                </v-card-text>
            </v-card>
        </template>
    </div>
</template>

<script>
import Opciones from './Opciones.vue';

export default {
  name: 'ListadoMobiles',
  props: {
    listadoObras: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">

</style>
